module.exports = __webpack_public_path__ + "img/headervisual-768-1x.b97d985b.jpg";